import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { slugRules } from "../../../utils/slug";
import JoditEditor from "jodit-react";
import { Select2Data } from "../../../utils/common";
import { getData } from "../../../utils/api";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getDimension } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    watch,
    control,
    getValues,
    trigger,
    formState: { errors },
    clearErrors,
  } = useForm();
  const imageFile = watch("image");

  const [categories, setCategories] = useState(null);
  const getAllCategories = async () => {
    const response = await getData(`/admin/masters/p-category`);
    console.log(response, "categories");
    if (response?.success) {
      setCategories(await Select2Data(response?.data?.data, "category_id"));
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("p_category_id", data?.p_category_id?.value);
      finalData.append("name", data?.name);
      finalData.append("alt_tag", data?.alt_tag ?? "");
      finalData.append("slug", data?.slug?.trim() || "");
      finalData.append("subname", data?.subname);
      finalData.append("description", data?.description);
      finalData.append("meta_title", data?.meta_title);
      finalData.append("meta_description", data?.meta_description);
      finalData.append("keywords", data?.keywords);
      finalData.append("schema_data", data?.schema_data);
      finalData.append("image", data.image[0]);

      const response = await postData(`/admin/blog`, finalData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response?.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
      clearErrors("image");
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Blog</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Category</Form.Label>
                    </div>
                    <InputGroup>
                      <Controller
                        name="p_category_id" // name of the field
                        {...register("p_category_id", {
                          required: "Select Category",
                        })}
                        control={control}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.p_category_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            options={categories}
                          />
                        )}
                      />
                    </InputGroup>
                    {errors.p_category_id && (
                      <span className="text-danger">
                        {errors.p_category_id.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="name"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "name is required",
                          validate: (value) =>
                            value.length <= 500 ||
                            "Data must be 500 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Slug</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="slug"
                        placeholder="e.g. my-blog-title"
                        className={classNames("", {
                          "is-invalid": errors?.slug,
                        })}
                        {...register("slug", slugRules)}
                      />
                    </InputGroup>
                    {errors.slug && (
                      <span className="text-danger">{errors.slug.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Sub Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="subname"
                        placeholder="subname"
                        className={classNames("", {
                          "is-invalid": errors?.subname,
                        })}
                        {...register("subname", {
                          required: "subname is required",
                          validate: (value) =>
                            value.length <= 500 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.subname && (
                      <span className="text-danger">
                        {errors.subname.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Summary</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Controller
                          name="description"
                          control={control}
                          rules={{
                            required: "description is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("description");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                      </InputGroup>
                      {errors.description && (
                        <span className="text-danger">
                          {errors.description.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Meta Title</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="meta_title"
                        placeholder="Meta Title"
                        className={classNames("", {
                          "is-invalid": errors?.meta_title,
                        })}
                        {...register("meta_title", {
                          required: "Meta title is required",
                        })}
                      />
                    </InputGroup>
                    {errors.meta_title && (
                      <span className="text-danger">
                        {errors.meta_title.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Meta Description</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="meta_description"
                        placeholder="Meta Description"
                        className={classNames("", {
                          "is-invalid": errors?.meta_description,
                        })}
                        {...register("meta_description", {
                          required: "Meta Description is required",
                        })}
                      />
                    </InputGroup>
                    {errors.meta_description && (
                      <span className="text-danger">
                        {errors.meta_description.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Meta Keywords</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="keywords"
                        placeholder="Meta Keywords"
                        className={classNames("", {
                          "is-invalid": errors?.keywords,
                        })}
                        {...register("keywords", {
                          required: "Meta Keywords is required",
                        })}
                      />
                    </InputGroup>
                    {errors.keywords && (
                      <span className="text-danger">
                        {errors.keywords.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Schema Data</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        name="schema_data"
                        placeholder="Schema Data"
                        className={classNames("", {
                          "is-invalid": errors?.schema_data,
                        })}
                        {...register("schema_data", {
                          required: "Schema Data is required",
                        })}
                      />
                    </InputGroup>
                    {errors.schema_data && (
                      <span className="text-danger">
                        {errors.schema_data.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Image</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="file"
                        name="image"
                        placeholder="Image"
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        {...register("image", {
                          required: "Image is required",
                          validate: async (value) => {
                            if (typeof value !== "string") {
                              const fileTypes = ["jpg", "png", "jpeg", "webp"];
                              const fileType = value[0].name?.split(".")[1];

                              if (!fileTypes?.includes(fileType)) {
                                return `please upload a valid file format. (${fileTypes})`;
                              }

                              const sizes = await getDimension(value[0]);
                              // if (sizes.width !== 1000 && sizes.height !== 1000) {
                              //   return "Image width and height must be 1000 px and 1000 px";
                              // }

                              // const fileSize = Math.round(
                              //   value[0].size / 1024
                              // );
                              // if (fileSize > 500) {
                              //   return "file size must be lower than 500kb";
                              // }
                            }
                          },
                        })}
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </InputGroup>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Label>Alt Tag</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="alt_tag"
                        placeholder="Alt Tag"
                        className={classNames("", {
                          "is-invalid": errors?.alt_tag,
                        })}
                        {...register("alt_tag", {
                          validate: (value) =>
                            !value ||
                            value.length <= 255 ||
                            "Data must be 255 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.alt_tag && (
                      <span className="text-danger">
                        {errors.alt_tag.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                {imagePreview && (
                  <div className="mt-2">
                    <img
                      src={imagePreview}
                      alt="Category Preview"
                      style={{ maxWidth: "100px" }}
                    />
                  </div>
                )}{" "}
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
